import { render, staticRenderFns } from "./DokumentPrilog.vue?vue&type=template&id=b38d8f08"
import script from "./DokumentPrilog.vue?vue&type=script&lang=js"
export * from "./DokumentPrilog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports